import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export default function createRouter() {
  return new Router({
    mode: 'history',
    routes: [
      {
        path: '/hello',
        name: 'HelloWorld',
        component: () => import(/* webpackChunkName:'post' */ '@/components/HelloWorld')
      },
      {
        path: '/first',
        name: 'FirstVue',
        component: () => import(/* webpackChunkName:'post' */ '@/components/First')
      },
      {
        path: '/',
        component: () => import(/* webpackChunkName:'home' */ '@/components/Home/Home'),
        name: 'home',
        meta: {
          keepAlive: true,
          index: 1
        }
      },
      {
        path: '/posts',
        component: () => import(/* webpackChunkName:'post' */ '@/components/Post/PostList'),
        name: 'postlist',
        meta: {
          keepAlive: false,
          index: 2
        }
      },
      {
        path: '/posts/search',
        component: () => import(/* webpackChunkName:'post' */ '@/components/Post/SearchPost'),
        name: 'searchpost'
      },
      {
        path: '/posts/:postid',
        component: () => import(/* webpackChunkName:'post' */ '@/components/Post/Post'),
        name: 'post',
        meta: { index: 3 }
      },
      {
        path: '/gallery',
        component: () => import(/* webpackChunkName:'post' */ '@/components/Gallery/GalleryList'),
        name: 'gallerylist',
        meta: { index: 2 }
      },
      {
        path: '/gallery/:galleryid',
        component: () => import(/* webpackChunkName:'post' */ '@/components/Gallery/Gallery'),
        name: 'gallery',
        meta: { index: 3 }
      },
      {
        path: '/album',
        component: () => import(/* webpackChunkName:'post' */ '@/components/Album/AlbumList'),
        name: 'albumlist',
        meta: { index: 2 }
      },
      {
        path: '/album/:albumid',
        component: () => import(/* webpackChunkName:'post' */ '@/components/Album/Album'),
        name: 'album',
        meta: { index: 3 }
      },
      {
        path: '/categories',
        component: () => import(/* webpackChunkName:'category' */ '@/components/Category/CategoryList'),
        name: 'categorylist',
        meta: { index: 2 }
      },
      {
        path: '/categories/:number',
        component: () => import(/* webpackChunkName:'category' */ '@/components/Category/Category'),
        name: 'category',
        meta: { index: 3 }
      },
      {
        path: '/topics/:number',
        component: () => import(/* webpackChunkName:'category' */ '@/components/Category/CategoryTopic'),
        name: 'topic',
        meta: { index: 2 }
      }
    ],
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      }
      return { x: 0, y: 0 }
    }
  })
}



// WEBPACK FOOTER //
// ./src/router/index.js